import { createSlice } from '@reduxjs/toolkit'

const TorkSettingsSlice = createSlice({
  name: 'TorkSettingsSlice',
  initialState: null,
  reducers: {
    setTorkSettings(state, action) {
      return action.payload;
    }
  }
})

export const { setTorkSettings } = TorkSettingsSlice.actions
export default TorkSettingsSlice.reducer
